import {
  UPDATE_SEGMENTS,
  UPDATE_USER
} from './types'

import i18n from '../plugins/i18n.js'

import * as api from '../utils/api'

export default {
  async [UPDATE_SEGMENTS] ({ commit }) {
    await api.getSegments().then(segments => {
      commit(UPDATE_SEGMENTS, segments)
    })
  },
  async [UPDATE_USER] ({ commit }) {
    await api.getUser().then(user => {
      i18n.locale = user.language
      commit(UPDATE_USER, user)
    })
  }
}
